import { render } from "./StudentPortal.vue?vue&type=template&id=60ce8f0c&scoped=true"
import script from "./StudentPortal.vue?vue&type=script&lang=js"
export * from "./StudentPortal.vue?vue&type=script&lang=js"

import "./StudentPortal.vue?vue&type=style&index=0&id=60ce8f0c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ce8f0c"]])

export default __exports__